import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const PRODUCT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.PRODUCT,
  false // No tenant ID in the base URL
);

export const productApi = {
  getProduct: id => apiClient.get(`${PRODUCT_BASE}/${id}`),
  createProduct: combinedData =>
    apiClient.post(`${PRODUCT_BASE}`, combinedData),
  updateProduct: (id, combinedData) =>
    apiClient.put(`${PRODUCT_BASE}/${id}`, combinedData),
  deleteProduct: id => apiClient.delete(`${PRODUCT_BASE}/${id}`)
};
export default productApi;
